import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface ClassTimetablePeriod {
  periodId: number;
  periodNumber: number;
  periodStart: string;
  periodEnd: string;
  periodType: 0 | 1 | 2; // 0=Break 2=Recess 1=class
  day: number;
  subjectId: number | null;
  subject: string | null;
  staffId: number | null;
  staffName: string | null;
}

export interface ClassTimetableRows {
  isTimetable: true;
  sunday: number;
  monday: number;
  tuesday: number;
  wednesday: number;
  thursday: number;
  friday: number;
  saturday: number;
  // Keyed by day number ("1" = Monday .. "5" = Friday, per numberOfDays),
  // each value an object keyed by period number ("1".."numberOfPeriods"),
  // NOT an array.
  periods: { [dayNumber: string]: { [periodNumber: string]: ClassTimetablePeriod } };
}

export interface GetClassTimetableResponse {
  status: boolean;
  rows: 'WIP' | ClassTimetableRows;
  message?: string;
}

export interface StaffTimetablePeriod {
  periodId: string;
  periodStart: string;
  periodEnd: string;
  subjectName: string;
  className: string;
}

export interface GetStaffTimetableResponse {
  status: boolean;
  body: {
    timeTable: { [dayName: string]: StaffTimetablePeriod[] };
  };
}

@Injectable({ providedIn: 'root' })
export class StaffTimetableService {
  private legacyUrl = AppSettings.API_ENDPOINT_STAFF_BASE;
  private v3Url = AppSettings.API_ENDPOINT_STAFF;
  private getClassTimetableEndpoint = apiConstants.getClassTimetable;
  private getStaffTimetableEndpoint = apiConstants.getStaffTimetable;

  constructor(private http: HttpClient) {}

  getClassTimetable(classId: number | string) {
    const params = new HttpParams().set('classId', classId);
    return this.http
      .get<GetClassTimetableResponse>(`${this.legacyUrl}${this.getClassTimetableEndpoint}`, { params })
      .pipe(map((res) => res));
  }

  getStaffTimetable(staffId: number | string) {
    const params = new HttpParams()
      .set('staffId', staffId)
      .set('lang', 'en');
    return this.http
      .get<GetStaffTimetableResponse>(`${this.v3Url}${this.getStaffTimetableEndpoint}`, { params })
      .pipe(map((res) => res));
  }
}
